// extracted by mini-css-extract-plugin
export default {"portalled-dropdown":"LfI3","portalledDropdown":"LfI3"};